<template>
    <v-tooltip-wrapper
        :max-width="330"
        :nudge-bottom="2"
        :open-delay="150"
        content-class="tooltip-glass tooltip-white elevation-8 tooltip-border-colored tooltip-border-sizenotmatching">
        <template #activator="{ on, attrs }">
            <i class="far fa-triangle-exclamation color-size-not-matching-icon"
               v-bind="{...$attrs, ...attrs}"
               v-on="{...$listeners, ...on}" />
        </template>
        <span v-html="text" />
    </v-tooltip-wrapper>
</template>

<script>
import VTooltipWrapper from '../../common/v-tooltip-wrapper.vue'

export default {
    components: { VTooltipWrapper },
    inheritAttrs: false,
    props: {
        text: String
    }
}
</script>
